import Button from "../../../components/Button";
import { useTargetOnScreen } from "../../../hooks/useTargetOnScreen";
import { COLORS } from "../../../styles/constant";
import * as Styled from "./index.styles";
import { LINKS } from "../../../constants/links";

const About = () => {
  const [containerRef, isVisible] = useTargetOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  });

  return (
    <Styled.AboutContainer id="home" ref={containerRef} isVisible={isVisible}>
      <div className="content-container">
        <div className="text-container">
          <img className="blob" src="/assets/images/home/blob.png" alt="blob" />

          <div className="title-container">
            <h1 className="name">Miyeon Lim,</h1>
            <span className="text-small">I am</span>
            <h1 className="job">Frontend Developer</h1>
          </div>

          <p className="desc">
            <span className="highlight">역도</span>와{" "}
            <span className="highlight">개</span>를 사랑하고{" "}
            <span className="highlight">지속적인 성장</span>을 추구하는 개발자
            <b> 임미연</b> 입니다.
          </p>

          <Button
            title="Resume"
            href={LINKS.resume}
            backgroundColor={`${COLORS.orange}`}
          />
        </div>

        <img
          className="powerlifting"
          src="/assets/images/home/yeokdo-jerk.png"
          alt="powerlifting"
        />

        <img
          className="downward-arrow"
          src="/assets/images/home/arrow-icon.png"
          alt="downward arrow"
        />
      </div>
    </Styled.AboutContainer>
  );
};

export default About;
